export default class ShareController {
  async share() {
    const url = this.urlValue
    const title = this.titleValue

    if (navigator.share) {
      try {
        await navigator.share({ url, title })
      } catch (error) {
        if (error.name !== 'AbortError') {
          console.error('Share error:', error)
        }
      }
    } else {
      try {
        await navigator.clipboard.writeText(url)
        this.showFeedback()
      } catch (error) {
        console.error('Clipboard error:', error)
      }
    }
  }

  showFeedback() {
    this.element.innerHTML = '<svg fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7" /></svg>'
    this.element.style.color = 'var(--success-green)'
    setTimeout(() => {
      this.element.innerHTML = this.originalHTML
      this.element.style.color = ''
    }, 2000)
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-controller="share"]').forEach(el => {
    const controller = new ShareController()

    controller.element = el
    controller.urlValue = el.dataset.shareUrlValue
    controller.titleValue = el.dataset.shareTitleValue
    controller.originalHTML = el.innerHTML

    el.addEventListener('click', (e) => {
      e.preventDefault()
      controller.share()
    })
  })
})
